import { useState } from "react";
import { getInitials } from "../utils/diaryUtils";

/** Photo when available, otherwise initials. */
const TeacherAvatar = ({ name, src, size }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <span className={`wd-avatar ${size === "lg" ? "wd-avatar--lg" : ""}`} aria-hidden="true">
      {src && !hasError ? <img src={src} alt="" onError={() => setHasError(true)} /> : getInitials(name)}
    </span>
  );
};

export default TeacherAvatar;
